import styled from '@emotion/styled'

export const SpreadsheetParseContainer = styled.div`
  display: flex;
  flex-direction: row;
`
export const SpreadsheetParseUploadPane = styled.div`
  display: flex;
  flex-direction: column;
  width: 400px;
`
export const SpreadsheetParseUploadAsideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 25px;
`
